export function canSpeakKorean(): boolean {
  return "speechSynthesis" in globalThis && "SpeechSynthesisUtterance" in globalThis;
}

export function speakKorean(text: string, privateOutputConfirmed: boolean): void {
  if (!privateOutputConfirmed) {
    throw new Error("의사 전용 이어폰 확인 후 음성 답변을 켜십시오.");
  }
  if (!canSpeakKorean()) {
    throw new Error("이 브라우저는 음성 출력을 지원하지 않습니다.");
  }
  globalThis.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "ko-KR";
  utterance.rate = 1;
  const koreanVoice = globalThis.speechSynthesis
    .getVoices()
    .find((voice) => voice.lang.toLocaleLowerCase().startsWith("ko"));
  if (koreanVoice) utterance.voice = koreanVoice;
  globalThis.speechSynthesis.speak(utterance);
}

export function stopSpeaking(): void {
  if ("speechSynthesis" in globalThis) globalThis.speechSynthesis.cancel();
}

export async function playReminderTone(): Promise<void> {
  const AudioContextConstructor =
    globalThis.AudioContext ??
    (globalThis as typeof globalThis & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;
  if (!AudioContextConstructor) return;
  const context = new AudioContextConstructor();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(880, context.currentTime);
  gain.gain.setValueAtTime(0.0001, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.08, context.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.22);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start();
  oscillator.stop(context.currentTime + 0.24);
  oscillator.addEventListener("ended", () => void context.close(), { once: true });
}
